export const links = {
  support: {
    learn_refunds:
      'https://support.xmoney.com/en/articles/4388032-how-refunds-work',
    contact_support: 'https://support.xmoney.com/en/',
    usdt_deprecation:
      'https://support.xmoney.com/en/articles/10757983-buyers-info-usdt-payments-no-longer-supported-due-to-mica-regulations',
  },
};
